<template>
  <nav class="flex space-x-4 items-center text-white">
    <img src="@/assets/winamp_logo.jpg" alt="logo" class="w-12 rounded-md"/>
    <p class="font-techMono text-xl">WINAMP</p>
    <div class="flex space-x-6 font-techMono">
    <router-link to="">File</router-link>
    <router-link to="">Play</router-link>
    <router-link to="">Options</router-link>
    <router-link to="">View</router-link>
    </div>
  </nav> 
</template>

